import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Maria G.',
  location: 'Houston, Texas',
  initials: 'MG',
  color: '#1B5E3B',
  stars: 5,
  before: 'Limpiaba casas 6 días a la semana. Llegaba tan cansada que no podía ni jugar con mis hijos.',
  after: 'En el primer mes gané $847 extra. Ahora estoy reduciendo mis horas de limpieza poco a poco. Por primera vez en años, siento que tengo control.',
  result: '+$847 en el primer mes'
}, {
  name: 'Daniela R.',
  location: 'Miami, Florida',
  initials: 'DR',
  color: '#C9973A',
  stars: 5,
  before: 'Tenía miedo de que fuera otra cosa que no funcionara. Ya había perdido dinero antes en "oportunidades".',
  after: 'Hice mi primera venta en 48 horas. Lloré. No lo podía creer. Fue la primera vez que gané dinero durmiendo.',
  result: 'Primera venta en 48 horas'
}, {
  name: 'Lorena M.',
  location: 'Los Angeles, California',
  initials: 'LM',
  color: '#2D7A52',
  stars: 5,
  before: 'No quería que nadie en mi trabajo supiera que tenía un negocio. Me daba vergüenza si fallaba.',
  after: 'Llevo $1,200 este mes y nadie sabe nada. Mis hijos sí saben. Y me ven diferente. Eso no tiene precio.',
  result: '$1,200 este mes'
}];
export function TestimonialsSection() {
  return <section style={{
    background: '#F2EDE4',
    padding: '80px 24px'
  }} data-id="element-338">
      <div style={{
      maxWidth: '1100px',
      margin: '0 auto'
    }} data-id="element-339">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} style={{
        textAlign: 'center',
        marginBottom: '52px'
      }} data-id="element-340">
          <span style={{
          display: 'inline-block',
          background: '#EAF4EE',
          color: '#1B5E3B',
          fontFamily: "'Lato', sans-serif",
          fontWeight: 700,
          fontSize: '11px',
          letterSpacing: '2px',
          textTransform: 'uppercase',
          padding: '6px 18px',
          borderRadius: '100px',
          marginBottom: '16px',
          border: '1px solid rgba(27,94,59,0.2)'
        }} data-id="element-341">
            Historias Reales
          </span>
          <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: 'clamp(26px, 3.5vw, 40px)',
          fontWeight: 700,
          color: '#1C1C1E',
          marginBottom: '12px'
        }} data-id="element-342">
            Mujeres que estaban exactamente donde tú estás ahora
          </h2>
          <p style={{
          fontFamily: "'Lato', sans-serif",
          fontSize: '16px',
          color: '#4A4A4A',
          maxWidth: '500px',
          margin: '0 auto'
        }} data-id="element-343">
            No son influencers. No son expertas en tecnología. Son madres que
            decidieron que ya era suficiente.
          </p>
        </motion.div>

        <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '20px'
      }} data-id="element-344">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: i * 0.15
        }} style={{
          background: '#fff',
          borderRadius: '18px',
          padding: '28px',
          boxShadow: '0 4px 24px rgba(28,28,30,0.07)',
          border: '1px solid #E8DDD0',
          position: 'relative'
        }} data-id="element-345">
              <Quote size={24} style={{
            color: '#E8DDD0',
            position: 'absolute',
            top: '20px',
            right: '20px'
          }} data-id="element-346" />

              <div style={{
            display: 'flex',
            gap: '3px',
            marginBottom: '20px'
          }} data-id="element-347">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} size={14} style={{
              color: '#C9973A',
              fill: '#C9973A'
            }} data-id="element-348" />)}
              </div>

              {/* Before */}
              <div style={{
            marginBottom: '16px'
          }} data-id="element-349">
                <p style={{
              fontFamily: "'Lato', sans-serif",
              fontSize: '11px',
              fontWeight: 700,
              color: '#8A8A8A',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              marginBottom: '6px'
            }} data-id="element-350">
                  Antes
                </p>
                <p style={{
              fontFamily: "'Lato', sans-serif",
              fontSize: '14px',
              color: '#6A6A6A',
              lineHeight: 1.7,
              fontStyle: 'italic',
              margin: 0
            }} data-id="element-351">
                  "{t.before}"
                </p>
              </div>

              {/* After */}
              <div style={{
            marginBottom: '20px'
          }} data-id="element-352">
                <p style={{
              fontFamily: "'Lato', sans-serif",
              fontSize: '11px',
              fontWeight: 700,
              color: '#1B5E3B',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              marginBottom: '6px'
            }} data-id="element-353">
                  Ahora
                </p>
                <p style={{
              fontFamily: "'Lato', sans-serif",
              fontSize: '14px',
              color: '#1C1C1E',
              lineHeight: 1.75,
              margin: 0
            }} data-id="element-354">
                  "{t.after}"
                </p>
              </div>

              {/* Result badge */}
              <div style={{
            background: '#EAF4EE',
            borderRadius: '8px',
            padding: '8px 12px',
            marginBottom: '18px',
            display: 'inline-block'
          }} data-id="element-355">
                <span style={{
              fontFamily: "'Lato', sans-serif",
              fontSize: '12px',
              fontWeight: 700,
              color: '#1B5E3B'
            }} data-id="element-356">
                  Resultado: {t.result}
                </span>
              </div>

              {/* Author */}
              <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }} data-id="element-357">
                <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: t.color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
              fontFamily: "'Lato', sans-serif",
              fontSize: '14px',
              fontWeight: 700,
              flexShrink: 0
            }} data-id="element-358">
                  {t.initials}
                </div>
                <div data-id="element-359">
                  <p style={{
                fontFamily: "'Lato', sans-serif",
                fontSize: '14px',
                fontWeight: 700,
                color: '#1C1C1E',
                margin: 0
              }} data-id="element-360">
                    {t.name}
                  </p>
                  <p style={{
                fontFamily: "'Lato', sans-serif",
                fontSize: '12px',
                color: '#8A8A8A',
                margin: 0
              }} data-id="element-361">
                    {t.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}